export var MediaType;
(function (MediaType) {
    MediaType["AUDIO"] = "AUDIO";
    MediaType["VIDEO"] = "VIDEO";
    MediaType["TEXT"] = "TEXT";
    MediaType["PDF"] = "PDF";
    MediaType["IMAGE"] = "IMAGE";
    MediaType["VIDEO_SEGMENTATION"] = "VIDEO_SEGMENTATION";
})(MediaType || (MediaType = {}));
export var DisplayType;
(function (DisplayType) {
    DisplayType["DICTATION"] = "DICTATION";
    DisplayType["INTAKER_WIZARD"] = "INTAKER_WIZARD";
    DisplayType["INTAKER_SCROLL"] = "INTAKER_SCROLL";
})(DisplayType || (DisplayType = {}));
